"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setDomainToScale;
/**
 * Function to set the d3 scale's domain. It accepts the 'original' array of domain values
 * or an object with 'min'/'max' fields to define only min / max bound or improve the syntax for domain bounds.
 * @param scale - one of Plottable.js scales (http://plottablejs.org/docs/modules/plottable.scales.html)
 * @param domain - specified domain with type 'AxisDomainT'
 */
function setDomainToScale(scale, domain) {
  if (!scale.domain) {
    throw new Error('Illegal Argument Exception: Provided Scale doesn\'t have \'domain\' method.');
  }

  // If we want to reset a domain value OR pass an explicit array of required domain values
  // (for example, an array of strings for categorical scale),
  // then we will need just to set the exact value
  if (domain === null || domain === undefined || Array.isArray(domain)) {
    scale.domain(domain);
    return;
  }

  // Otherwise, we may want to set domain value with an explicit syntax
  // or one of the domain bounds
  var min = domain.min,
    max = domain.max;
  if (min !== undefined && max !== undefined) {
    scale.domain([min, max]);
    return;
  }
  if (min !== undefined && scale.domainMin) {
    scale.domainMin(min);
  }
  if (max !== undefined && scale.domainMax) {
    scale.domainMax(max);
  }
}
//# sourceMappingURL=setXYScaleDomain.js.map